import { CALL_API } from '../middleware';
import { FaqDataInfo, GET_FAQS, GET_FAQS_SUCCESS } from '../types/faq';

export const getFaqs =
    () =>
        async (dispatch: any): Promise<FaqDataInfo> => {
            try {
                return await dispatch({
                    [CALL_API]: {
                        url: '/user/faqs',
                        method: 'GET',
                        types: [GET_FAQS_SUCCESS, GET_FAQS],
                        enableFixture: true,
                        json: `faq.json`,
                        enableForProduction: true,
                    },
                });
            } catch (err: any) {
                throw err;
            }
        };
